import styled from 'styled-components'

export default styled.div`
  width: 40px;
  height: 26px;
  margin-right: 16px;
  background: url('${props => props.src}') no-repeat left center;
  background-size: contain;
`
